/**
 * FlowV2 interactive debugger adapters keyed by FlowDebugger from channel config.
 * Add new kinds here without changing FlowV2_v1 core layout.
 */

export const DEBUGGER_WEBRTC = 'webrtc';
export const DEBUGGER_NONE = 'none';

/**
 * @typedef {object} DebugAdapterContext
 * @property {object} editor - FlowV2 component instance
 * @property {boolean} stepping
 * @property {object} [debugArgs]
 */

/**
 * @returns {{ needsMediaSetup: boolean, start: (ctx: DebugAdapterContext) => Promise<void> }}
 */
export function getDebugAdapter(flowDebugger) {
    const kind = flowDebugger || DEBUGGER_NONE;
    if (kind === DEBUGGER_WEBRTC) {
        return {
            needsMediaSetup: true,
            async start(ctx) {
                const editor = ctx.editor;
                if (ctx.debugArgs?.enableMedia) {
                    editor.WebRtcConnectedFunc = () => editor.debugStartWebRtc(ctx.stepping);
                    await editor.debugSetupWebRtc();
                    return;
                }
                // Softphone skipped: Call IVR entry needs SessionId — start user flow directly (null media).
                await editor.debugStartWithoutMedia(ctx.stepping);
            },
        };
    }
    return {
        needsMediaSetup: false,
        async start(ctx) {
            // Email / SMS / API: entry project when FlowDebugProjectRef is set; else direct start
            await ctx.editor.debugStartWithoutMedia(ctx.stepping);
        },
    };
}

export function showWebRtcChrome(flowDebugger) {
    return (flowDebugger || DEBUGGER_NONE) === DEBUGGER_WEBRTC;
}
